import { memo } from 'react';

import { QuickLinks } from './QuickLinks';

export * from './QuickLinks';
export { events, type QuickLinkItem, type QuickLinksProps } from './types';

export default memo(QuickLinks);
